/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
// import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Routes, Route, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import Presentation from "layouts/pages/presentation";
import CEO from "pages/LandingPages/CEO";
import Error404Page from "pages/LandingPages/Error404Page";
import ContactUsPage from "layouts/pages/landing-pages/contact-us";
import BudgetEstimate2025_2026 from "pages/LandingPages/BudgetEstimate2025_2026";
import BudgetEstimate2026_2027 from "pages/LandingPages/BudgetEstimate2026_2027";
import PGE_42_MainPage from "pages/LandingPages/PGE_42_MainPage";
import PGE_42 from "pages/LandingPages/PGE_42";
import PGE_41 from "pages/LandingPages/PGE_41";
import PGE_40 from "pages/LandingPages/PGE_40";
import PictouWestByElection from "pages/LandingPages/PictouWestByElection";
import News from "pages/LandingPages/News";
import PrivacyPolicy from "pages/LandingPages/PrivacyPolicy";
// import FederalElection2025 from "pages/LandingPages/FederalElection2025";
import EModule from "pages/LandingPages/EModule";
// Material Kit 2 React routes
import routes from "routes";
import MapOrderForm from "pages/LandingPages/ElectoralDistrictMap/map_order/MapOrderForm";
import FeatureStory from "pages/LandingPages/FeatureStory";
import FeatureStory2026 from "pages/LandingPages/FeatureStory2026";
import ENSOutreachPlan from "pages/LandingPages/ENSOutreachPlan";
import ENStratergicPlan2026_2030 from "pages/LandingPages/ENStratergicPlan2026-2030";
import ThirdParties from "pages/LandingPages/ThirdParties";
import Cheticamp from "pages/LandingPages/Cheticamp";
// import CheticampCandidates from "pages/LandingPages/CheticampCandidates";
import Compliance from "pages/LandingPages/Compliance";
import GetOnTheVotersList from "pages/LandingPages/GetOnTheVotersList";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Presentation />} />
        <Route path="/home" element={<Presentation />} />
        {/* <Route path="*" element={<Navigate to="/home" />} /> */}
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/ceo" element={<CEO />} />
        <Route path="/budgetEstimate2025_2026" element={<BudgetEstimate2025_2026 />} />
        <Route path="/budgetEstimate2026_2027" element={<BudgetEstimate2026_2027 />} />
        {/* <Route path="/federalElection2025" element={<FederalElection2025 />} /> */}
        <Route path="/provincialGeneralElections" element={<PGE_42_MainPage />} />
        <Route path="/generalElection_42nd" element={<PGE_42 />} />
        <Route path="/generalElection_41st" element={<PGE_41 />} />
        <Route path="/generalElection_40th" element={<PGE_40 />} />
        <Route path="/PictouWestByElection" element={<PictouWestByElection />} />
        <Route path="/news" element={<News />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Error404Page />} />
        <Route path="/E-Module" element={<EModule />} />
        <Route path="/MapOrderForm" element={<MapOrderForm/>}/>
        <Route path="/AnnualReport2025" element={<FeatureStory/>}/>
        <Route path="/AnnualReport2026" element={<FeatureStory2026/>}/>
        <Route path="/ENSOutreachPlan" element={<ENSOutreachPlan/>}/>
        <Route path="/ENStratergicPlan2026_2030" element={<ENStratergicPlan2026_2030/>}/>
        <Route path="/ThirdParties" element={<ThirdParties/>}/>
        <Route path="/ChéticampBy-election2026" element={<Cheticamp/>}/>
        {/* <Route path="/ChéticampBy-election2026_Candidates" element={<CheticampCandidates/>}/> */}
        <Route path="/compliance" element={<Compliance/>}/>
        <Route path="/voters" element={<GetOnTheVotersList/>}/>
      </Routes>
    </ThemeProvider>
  );
}
